import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=65b155b7&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=65b155b7&prod&lang=scss"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=65b155b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b155b7",
  null
  
)

export default component.exports